import React, { useEffect } from 'react';
import { Routes, Route, Navigate, useOutletContext } from 'react-router-dom';
import Layout from '../components/Layout';

// Import all admin page components
import Dashboard from "../admin_pages/Dashboard";
import College from "../admin_pages/College";
import University from "../admin_pages/University";
import Degree from "../admin_pages/Degree";
import AcademicYear from "../admin_pages/AcademicYear";
import Category from "../admin_pages/Category";
import ProgrammeYearPage from "../admin_pages/ProgrammeYear";
import SemsterPage from "../admin_pages/Semster";
import CreditHoursPage from "../admin_pages/CreditHours";
import Discipline from "../admin_pages/Discipline";
import Program from "../admin_pages/Program";
import Courses from '../admin_pages/Courses';
import EduCourseType from "../admin_pages/EduCourseType";
import DepartmentPage from "../admin_pages/Department";
import ComponentMasterPage from "../admin_pages/ComponentMaster";
import DesignationPage from "../admin_pages/Designation";
import StaffTypePage from "../admin_pages/StaffType";
import StaffProfilePage from "../admin_pages/StaffProfile";
import StudentProfile from '../admin_pages/StudentProfile';
import RegistrationType from "../admin_pages/RegistrationType";
import Examination from "../admin_pages/Examination";
import Section from "../admin_pages/Section";
import UpdateStudentSection from "../admin_pages/UpdateStudentSection";
import StudentIdFormat from '../admin_pages/StudentIdFormat';
import FacultyCourseMapping from '../admin_pages/FacultyCourseMapping';
import GetStudentEnquiry from '../admin_pages/GetStudentEnquiry';
import SemesterRegistration from '../admin_pages/SemesterRegistration'; 
import ExamTimeTable from '../admin_pages/ExamTimeTable';
import RoomMaster from '../admin_pages/RoomMaster';
import ExamAttendance from '../admin_pages/ExamAttendance';
import AttendanceSheetGenerator from '../admin_pages/AttendanceSheetGenerator';
import RolePage from '../admin_pages/RolePage';
import FeeTypePage from '../admin_pages/FeeType';
import FeeCategoryPage from '../admin_pages/FeeCategory';
import FeeMaster from '../admin_pages/FeeMaster';

// PageWrapper component to handle page titles
const PageWrapper = ({ children, title }) => {
  const context = useOutletContext();
  useEffect(() => {
    const setPageTitle = context?.setPageTitle;
    if (setPageTitle && title) {
      setPageTitle(title);
    }
  }, [title, context]);
  return <>{children}</>;
};

// Placeholder component for pages that are not yet built
const PlaceholderPage = ({ title }) => (
  <div style={{ padding: '40px', textAlign: 'center' }}>
    <h2>{title} - Coming Soon 🚧</h2>
    <p>This feature will be available soon.</p>
  </div>
);

export default function AdminRoutes() {
  return (
    <Routes>
      <Route element={<Layout />}>
        {/* Default redirect */}
        <Route index element={<Navigate to="dashboard" replace />} />
        
        {/* Dashboard */}
        <Route path="dashboard" element={<PageWrapper title="Admin Dashboard"><Dashboard /></PageWrapper>} />
        
        {/* PHASE 1: Institution Setup - Basic Masters */}
        <Route path="university" element={<PageWrapper title="University Management"><University /></PageWrapper>} />
        <Route path="college" element={<PageWrapper title="College Management"><College /></PageWrapper>} />
        <Route path="academic-year" element={<PageWrapper title="Academic Year"><AcademicYear /></PageWrapper>} />
        <Route path="category" element={<PageWrapper title="Category Management"><Category /></PageWrapper>} />
        <Route path="role-master" element={<PageWrapper title="Role Management"><RolePage /></PageWrapper>} />
        
        {/* PHASE 2: Academic Structure Setup */}
        <Route path="degree" element={<PageWrapper title="Degree Management"><Degree /></PageWrapper>} />
        <Route path="discipline" element={<PageWrapper title="Discipline Management"><Discipline /></PageWrapper>} />
        <Route path="program" element={<PageWrapper title="Program Management"><Program /></PageWrapper>} />
        <Route path="programme-year" element={<PageWrapper title="Programme Year"><ProgrammeYearPage /></PageWrapper>} />
        <Route path="semster" element={<PageWrapper title="Semester Management"><SemsterPage /></PageWrapper>} />
        
        {/* PHASE 3: Course & Credit Setup */}
        <Route path="educoursetype" element={<PageWrapper title="Education Course Type"><EduCourseType /></PageWrapper>} />
        <Route path="credit-hours" element={<PageWrapper title="Credit Hours"><CreditHoursPage /></PageWrapper>} />
        <Route path="component-master" element={<PageWrapper title="Component Master"><ComponentMasterPage /></PageWrapper>} />
        <Route path="courses" element={<PageWrapper title="Courses Management"><Courses /></PageWrapper>} />
        
        {/* PHASE 4: Department & Staff Setup */}
        <Route path="department" element={<PageWrapper title="Department Management"><DepartmentPage /></PageWrapper>} />
        <Route path="designation" element={<PageWrapper title="Designation Management"><DesignationPage /></PageWrapper>} />
        <Route path="staff-type" element={<PageWrapper title="Staff Type"><StaffTypePage /></PageWrapper>} />
        <Route path="staff-profile" element={<PageWrapper title="Staff Profile"><StaffProfilePage /></PageWrapper>} />
        
        {/* PHASE 5: Faculty-Course Assignment */}
        <Route path="faculty-course-mapping" element={<PageWrapper title="Faculty Course Mapping"><FacultyCourseMapping /></PageWrapper>} />
        
        {/* PHASE 6: Student Admission & Management */}
        <Route path="enquiries" element={<PageWrapper title="Student Enquiries"><GetStudentEnquiry /></PageWrapper>} />
        <Route path="registrationtype" element={<PageWrapper title="Registration Type"><RegistrationType /></PageWrapper>} />
        <Route path="student-id-format" element={<PageWrapper title="Student ID Format"><StudentIdFormat /></PageWrapper>} />
        <Route path="studentprofile" element={<PageWrapper title="Student Profile"><StudentProfile /></PageWrapper>} />
        
        {/* PHASE 7: Section & Class Organization */}
        <Route path="section" element={<PageWrapper title="Section Management"><Section /></PageWrapper>} />
        <Route path="updatestudentsection" element={<PageWrapper title="Update Student Section"><UpdateStudentSection /></PageWrapper>} />
        
        {/* PHASE 8: Semester Operations */}
        <Route path="semesterregistration" element={<PageWrapper title="Semester Registration"><SemesterRegistration /></PageWrapper>} />
        
        {/* PHASE 9: Examination Management */}
        <Route path="examination" element={<PageWrapper title="Examination Management"><Examination /></PageWrapper>} />
        <Route path="exam-timetable" element={<PageWrapper title="Exam Timetable"><ExamTimeTable /></PageWrapper>} />
        <Route path="room-master" element={<PageWrapper title="Room Management"><RoomMaster /></PageWrapper>} />
        <Route path="exam-attendance" element={<PageWrapper title="Exam Attendance"><ExamAttendance /></PageWrapper>} />
        <Route path="generate-attendance" element={<PageWrapper title="Generate Attendance"><AttendanceSheetGenerator /></PageWrapper>} />
        
        {/* PHASE 10: Fees Managment*/}
<Route path="fee-type" element={<PageWrapper title="Fee Type"><FeeTypePage /></PageWrapper>} />
<Route path="fee-categories" element={<PageWrapper title="Fee Type"><FeeCategoryPage /></PageWrapper>} />
<Route path="fee-master"  element={ <PageWrapper title="Fee Master">  <FeeMaster /> </PageWrapper> } />

        {/* Reports */}
        <Route path="student-reports" element={<PlaceholderPage title="Student Reports" />} />
        <Route path="staff-reports" element={<PlaceholderPage title="Staff Reports" />} />
        <Route path="academic-reports" element={<PlaceholderPage title="Academic Reports" />} />
        
        {/* Settings */}
        <Route path="profile" element={<PlaceholderPage title="Profile Settings" />} />
        <Route path="settings" element={<PlaceholderPage title="System Settings" />} />
      </Route>
    </Routes>
  );
}